import { RequestDeliveryInfo } from "./RequestDeliveryInfoModel";
import { RequestRemark } from "./RequestRemarkModel";
import { RequestUnserviceablePostModel } from "./RequestUnserviceableModel";

export class RequestOrderCreateModel {
  public ContractId?: number;
  public RefNo?: string;
  public isDefined?: boolean;
  public PreDefinedComponentId?: number;
  public CustomerRequestComponent?: string;
  public ComponentDescription?: string;
  public RequestedDeliveryDate?: Date;
  public Chapter?: number;
  public ReleaseType?: string;
  public AircraftId?: number;
  public AirportCode?: string;
  public CustomerPo?: string;
  public CustomerPoLine?: string;
  public RequestType?: number;
  public Access?: boolean;
  public Repair?: boolean;
  public isPool?: boolean;
  public RequestStatus?: number;
  public isFlightArrived?: boolean;
  public MelCategory?: string;
  public RepairTat?: number;
  public RequestRemark?: RequestRemark;
  public RequestDeliveryInfo?: RequestDeliveryInfo;
  public RequestUnserviceable?: RequestUnserviceablePostModel;
  public AcRegistration?: string;
}
